export default "__VITE_ASSET__Yi64cnoa__"